import styled from 'styled-components';

// Constants
import breakpoints from 'constants/breakpoints';

export const TitleContainer = styled.div`
  h1.ant-typography {
    color: var(--color-neutral__landing-page-text, var(--color-neutral__title-active));
    font-family: var(--title_font);
    font-size: var(--title_font_size, 1.5rem);
    font-weight: 500;
    line-height: 1.1;
    margin-bottom: 0;
    text-align: center;

    @media (min-width: ${breakpoints.md}px) {
      font-size: var(--title_font_size, 2.5rem);
      font-weight: 300;
      line-height: 1.1;
      text-align: var(--content-align, start);

      // Prevent widows when text is divided by <span> tags (e.g., <span>Order Food</span> <span>and Drink</span>).
      span {
        display: inline-block;
      }
    }
  }
`;

export const StyledRichText = styled.div`
  p,
  p span,
  p span sup,
  p span sub,
  p span sup em,
  p strong {
    color: var(--color-neutral__landing-page-text, var(--color-neutral__body));
    font-family: var(--default-font);
    line-height: 1.5;
    text-align: center;

    @media (min-width: ${breakpoints.md}px) {
      text-align: var(--content-align, start);
    }

    &:last-child {
      margin-bottom: 0px;
    }
  }

  strong {
    font-weight: 500;
  }

  // The .default-bbot-template__ classes are applied in railbot_app:views_for_consumer.py.
  .default-bbot-template__rich-text--learn-more {
    font-size: 0.875rem;
    text-align: center;

    a {
      text-decoration: underline;
    }

    p {
      margin-bottom: 0.25rem;
    }

    @media (min-width: ${breakpoints.md}px) {
      text-align: left;
      font-size: 1rem;
    }
  }

  .default-bbot-template__rich-text--location-code {
    font-size: 0.875rem;
    text-align: center;

    @media (min-width: ${breakpoints.md}px) {
      font-size: 1rem;
      text-align: left;

      p {
        margin-bottom: 0.5rem;
      }

      span {
        display: inline-block;
      }
    }
  }
`;

export const Divider = styled.div`
  border-bottom: 2px solid var(--color-neutral__line);
  width: 44px;

  &.default-bbot-template__mini-divider {
    margin: 20px auto;

    @media (min-width: ${breakpoints.md}px) {
      margin: 20px 0;
    }
  }
`;

export const DividerContainer = styled.div`
  .divider {
    display: flex;
    flex-direction: row;
    opacity: 0.5;
  }

  .divider span {
    margin: 0 20px;
    color: var(--color-neutral__landing-page-text, var(--color-neutral__title-active));
  }

  .divider:before,
  .divider:after {
    content: '';
    flex: 1 1;
    border-bottom: 1px solid var(--color-neutral__landing-page-text, var(--color-neutral__title-active));
    margin: auto;
  }
`;

export const InfoWindowContentContainer = styled.div`
  padding: 0.5rem;
`;

export const InfoWindowContentHeading = styled.span`
  color: var(--color-neutral__title-active);
  display: block;
  font-weight: bold;
  font-size: 0.875rem;
  line-height: 1.2;
  letter-spacing: 0.5px;
  padding-bottom: 0.75rem;
`;

export const InfoWindowContentPhoneAddress = styled.div`
  font-size: 0.75rem;
  line-height: 1.5;
  opacity: 0.7;
`;

export const InfoWindowContentStoreHours = styled.div`
  * {
    color: var(--color-neutral__body);
    font-size: 0.75rem;
    letter-spacing: 0.5px;
    line-height: 1.5;
    margin-bottom: 0;
    margin-top: 0.25rem;
    opacity: 0.7;
    word-break: break-word;

    &:first-child {
      margin-top: 0;
    }
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-top: 1rem;

    &:first-of-type {
      margin-top: 0;
    }
  }
`;

export const InfoWindowContentStoreHoursContainer = styled.div`
  padding-top: 0.75rem;
`;

export const MapDiv = styled.div`
  height: 100%;
  max-height: 100vh;
`;
